import React from 'react';
import { ContractDetails } from 'components';

function ContractDetailsComponent() {
    return <ContractDetails />;
}
export default ContractDetailsComponent;
